"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upgradeCatalogApi = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var ENDPOINT_URL = '/self-service/v2/product-catalog-list';

var portalId = _hubspot.default.get();

var _cachedGet;

var upgradeCatalogApi = {
  get: function get() {
    if (_cachedGet) {
      return _cachedGet;
    }

    _cachedGet = _apiClient.default.get(ENDPOINT_URL, {
      query: {
        appAuth: true,
        authPortal: portalId
      }
    });
    return _cachedGet;
  }
};
exports.upgradeCatalogApi = upgradeCatalogApi;